module Main exposing (..)

import Audio exposing (Audio, AudioData)
import Dict
import Domain.Types exposing (AudioState(..), Message(..), Model, PlayingState(..))
import Duration
import Init
import Subscriptions exposing (audioPortFromJS, audioPortToJS, subscriptions)
import Update
import View


main : Platform.Program () (Audio.Model Message Model) (Audio.Msg Message)
main =
    Audio.applicationWithAudio
        { view = View.view
        , init = Init.init
        , update = Update.update
        , subscriptions = subscriptions
        , onUrlChange = UrlChanged
        , onUrlRequest = LinkClicked
        , audio = audio
        , audioPort = { toJS = audioPortToJS, fromJS = audioPortFromJS }
        }


audio : AudioData -> Model -> Audio
audio _ { currentSounds, audioModel } =
    let
        kanaAudio =
            audioModel.kanaSounds
                |> Dict.filter (\key _ -> currentSounds |> List.any (\soundName -> soundName == key))
                |> Dict.toList
                |> List.map (\( _, audioState ) -> audioState |> audioStateToAudio)

        wordAudio =
            audioModel.wordSounds
                |> Dict.filter (\key _ -> currentSounds |> List.any (\soundName -> soundName == key))
                |> Dict.toList
                |> List.map (\( _, audioState ) -> audioState |> audioStateToAudio)

        soundEffectsAudio =
            audioModel.soundEffects
                |> Dict.filter (\key _ -> currentSounds |> List.any (\soundName -> soundName == key))
                |> Dict.toList
                |> List.map (\( _, audioState ) -> audioState |> audioStateToAudio)
    in
    kanaAudio
        |> List.append wordAudio
        |> List.append soundEffectsAudio
        |> Audio.group


audioStateToAudio : AudioState -> Audio
audioStateToAudio audioState =
    case audioState of
        LoadedAudio loadedAudio ->
            case loadedAudio.playingState of
                NotPlaying ->
                    Audio.silence

                Playing time ->
                    Audio.audio loadedAudio.sound time

                FadingOut startTime stopTime ->
                    Audio.audio loadedAudio.sound startTime
                        |> Audio.scaleVolumeAt
                            [ ( stopTime, 1 )
                            , ( Duration.addTo stopTime (Duration.seconds 2), 0 )
                            ]

        _ ->
            Audio.silence
